"use strict"
# sw ------------- chk Modern PC (not IE) SMP 強化版 IE11 add
userAgent = window.navigator.userAgent.toLowerCase()
appVersion = window.navigator.appVersion.toLowerCase()
uaName = "unknown"
ios = undefined
aos = undefined
uaNameVer = undefined
unless userAgent.indexOf("msie") is -1
  uaName = "ie"
  unless appVersion.indexOf("msie 6.") is -1       then uaName = "ie6" else unless appVersion.indexOf("msie 7.") is -1  then uaName = "ie7" else unless appVersion.indexOf("msie 8.") is -1  then uaName = "ie8" else unless appVersion.indexOf("msie 9.") is -1  then uaName = "ie9" else unless appVersion.indexOf("msie 10.") is -1 then uaName = "ie10"
else unless userAgent.indexOf("trident/7") is -1   then uaName = "ie11" else unless userAgent.indexOf("chrome") is -1      then uaName = "chrome" else unless userAgent.indexOf("ipad") is -1
  ios = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/)
  uaNameVer = [parseInt(ios[1], 10), parseInt(ios[2], 10), parseInt(ios[3] or 0, 10)]
  uaName = "ipad"
else unless userAgent.indexOf("ipod") is -1
  ios = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/)
  uaNameVer = [parseInt(ios[1], 10), parseInt(ios[2], 10), parseInt(ios[3] or 0, 10)]
  uaName = "ipod"
else unless userAgent.indexOf("iphone") is -1
  ios = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/)
  uaNameVer = [parseInt(ios[1], 10), parseInt(ios[2], 10), parseInt(ios[3] or 0, 10)]
  uaName = "iphone" # + uaNameVer
else unless userAgent.indexOf("android") is -1
#aos = userAgent.substr(userAgent.indexOf('android')+8, 5)
  aos = userAgent.match(/android (\d+).(\d+).?(\d+)?/)
  uaName = "android"
else unless userAgent.indexOf("safari") is -1     then uaName = "safari" else unless userAgent.indexOf("gecko") is -1      then uaName = "gecko" else unless userAgent.indexOf("opera") is -1      then uaName = "opera" else uaName = "mobile"  unless userAgent.indexOf("mobile") is -1


do ($ = jQuery, win = @window, doc = @document) ->
# init Assy
  $win = $(win)
  $doc = $(doc)

  #プリロードスニペットSW
  cache = []
  $.preLoadImages = ->
    args_len = arguments.length
    i = args_len

    while i--
      cacheImage = document.createElement("img")
      cacheImage.src = arguments[i]
      cache.push cacheImage

  $.preLoadImages(
  )
  #preload Imgs

  #--------------- image rollover function
  imgRollover = (target) ->
    outImgName = "_ovoff"
    overImgName = "_ovon"
    preload = new Array()
    targetArea = $("" + target + "")
    imgTagData = $("img,input", targetArea)
    reOverImg = new RegExp(outImgName + "+(.[a-z]+)$")
    reOutImg = new RegExp(overImgName + "+(.[a-z]+)$")
    imgTagData.each (i) ->
      if $(this).attr("src")?
        if $(this).attr("src").match(reOverImg)
          $("<img>").attr "src", $(this).attr("src")
            .replace(reOverImg, overImgName + "$1")
          $(this).bind "mouseover", ->
            $(this).attr "src", $(this).attr("src")
              .replace(reOverImg, overImgName + "$1")
          $(this).bind "mouseout", ->
            $(this).attr "src", $(this).attr("src")
              .replace(reOutImg, outImgName + "$1")

  #shuffle
  $.fn.shuffle = ->
    @.each ->
      items = $("#shuffle .shuf").clone(true)
      (if (items.length) then $(this).html($.shuffle(items)) else this)

  # ---------------------------- shuffle
  $.shuffle = (arr) ->
    j = undefined
    x = undefined
    i = arr.length

    while i
      j = parseInt(Math.random() * i)
      x = arr[--i]
      arr[i] = arr[j]
      arr[j] = x
    arr

  # トップに戻る
  goToTop = ->
# --------------------- GoToTop
    $("body").append "<p id='goto-top'><span>上に戻る</span></p>"
    $("#goto-top").hide()
    #少したったら消したいから。
    funcTimeout = -> $("#goto-top").fadeOut()
    $.timeout = (time) ->
      $.Deferred((dfd) -> setTimeout dfd.resolve, time).promise()
    $win.on "scroll", ->
      if $(@).scrollTop() > 555 then $("#goto-top").stop(true, true).fadeIn() else $("#goto-top").fadeOut()
    $("#goto-top").on "click", (e) ->
      e.preventDefault()
      $("body,html").animate
        scrollTop: 0
      , 200

  $ ->
#-------------- DOM make Assy ------------------------###
    imgRollover("body") #initRollOvers()
    goToTop()

    #BlockLink
    $(".hNavi").on "click", (e) ->
      e.preventDefault()
      #e.stopPropagation()
      window.open $(this).find("a").attr("href")
      , $(this).find("a").attr("target") || "_self"
      .css cursor: "pointer"


#-------------- UI Assy ------------------------------###

